const websiteConfigCollection = require('od-modules/collections/website.collection').getInstance();
const createWidgetLoader = require('components-framework/widget/create_widget_loader');
const conchitaFactory = require('components/conchita/js/main');
const desktopTemplate = require('../templates/desktop/lightbox.html');
const mobileTemplate = require('../templates/mobile/lightbox.html');

const isDesktop = () => Odigeo.SessionScope.flow === 'desktop';
const getTemplate = () => isDesktop() ? desktopTemplate : mobileTemplate;

class DownloadAppNotification {
    constructor() {
        this.widgetLoader = createWidgetLoader({
            conchita: ['conchita', conchitaFactory],
        });
        this.template = Odigeo._.template(getTemplate(), Odigeo.Utils.getTmplSettings());
    }

    renderTemplate() {
        return this.template();
    }

    loadDownloadComponent(bookingInfoData, notificationType) {
        websiteConfigCollection.getLoadedPromise().then(() => {
            import(/* webpackChunkName: "frontend-booking-management" */ '@edreamsodigeo/frontend-booking-management').then((bookingManagement) => {
                this.widgetLoader.get('conchita')
                    .execute('load', {
                        identifier: 'conchita-download-app-notification',
                        container: 'conchita-download-app-notification',
                        component: bookingManagement.voluntaryStatusDownloadAppContainer,
                        translationPath: '/secure/translations/mmb',
                        data: {
                            bookingInfo: bookingInfoData,
                            notificationType: notificationType,
                        },
                        conchitaLiveContent: true,
                        module: 'mmb',
                    });
            });
        });
    }
}

module.exports = new DownloadAppNotification();
